<!--USAGE-->
<!--<new-checkbox-->
<!--  :init-state="isAgreeTerms"-->
<!--  @change-checkbox="changeCheckbox"-->
<!--&gt;-->
<!--  <template slot="content">-->
<!--    <div>Регистрацией вы подтверждаете согласие</div>-->
<!--    <div>-->
<!--      с-->
<!--      <a href="https://google.com" class="login__checkbox-link" target="_blank">-->
<!--        публичной офертой-->
<!--      </a>-->
<!--    </div>-->
<!--  </template>-->
<!--</new-checkbox>-->

<template>
  <div class="login__checkbox" @click="changeCheckbox">
    <div :class="['login__checkbox-check', { checked: isChecked }]">
    <img src="@/assets/img/check.svg" alt="check">
  </div>
    <div class="login__checkbox-desription">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewCheckbox',
  props: {
    initState: {
      type: Boolean,
      default: false,
    },
    dropCheckbox: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChecked: false,
    }
  },
  watch: {
    dropCheckbox() {
      if (this.dropCheckbox) {
        this.isChecked = false
      }
    },
  },
  mounted() {
    this.isChecked = this.initState
  },
  methods: {
    changeCheckbox() {
      this.isChecked = !this.isChecked
      this.$emit('change-checkbox')
    },
  },
}
</script>

<style lang="sass" scoped>
.login__checkbox
  display: flex
  align-items: center
  margin-bottom: 2.4rem
  cursor: pointer

  &-check
    display: flex
    justify-content: center
    align-items: center
    width: 2.4rem
    height: 2.4rem
    margin-right: 1.6rem
    box-sizing: border-box
    border: 2px solid #d7d7d7
    border-radius: 0.4rem
    &.checked
      border: none
      background: green
    img
      width: 1.6rem
      height: 1.6rem

  &-description
    font-size: 1.6rem
    font-weight: 400
    line-height: 2rem
    color: #181818

  /* здесь можно добавить стили для разметки, */
  /* используемой внутри слота */
</style>
